import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 51578 54390"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:none}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M49715 43256 32005 25421l8054-8054 7194-4635 2862-5144-3325-3328-5143 2867-4639 7190-8045 8049-7983-8017-33-10587L10124 860 8966 2011l5756 5749-5614 5624-5751-5747-1158 1143 2906 10826 10296 28-63 66 8133 8168-3007 3008-1975-1969-3041 3044 946 940c-2734 1047-10278 8592-11327 11321l-939-939-3038 3044 6982 6982 3047-3044-949-949c2734-1037 10280-8589 11323-11316l943 946 3044-3048-1969-1969 2999-3002 17750 17794c1528 1453 3942 1455 5419-40 1495-1487 1499-3895 36-5415z"
        className="fill-none stroke1"
        style={{
          stroke: "#1c1b17",
          strokeWidth: 1542.33,
        }}
      />
      <circle
        cx={44962}
        cy={44252}
        r={771}
        className="fill-none stroke1"
        style={{
          stroke: "#2b2a29",
          strokeWidth: 1542.33,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
